import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-to',
  templateUrl: './how-to.component.html',
  styleUrls: ['./how-to.component.css']
})
export class HowToComponent implements OnInit {
  galleryItems = [
    { id: 1, type: 'podcast', url: '4FKLKITaQbEshHvihVCec3', title: 'What\'s the Most Climate-Friendly Way to Use My Land? A HTSAP House Call' },
    { id: 2, type: 'podcast', url: '2XiHg1jrEGWg3gXvyaUgvb', title: 'Meet The Influencer Who Wants You To Buy LESS Stuff'},
    { id: 3, type: 'podcast', url: '36qB5r3TJmyYkZwp9wfmVx', title: 'Waste, Worms and Windrows: Domingo Morales\' Quest to Make Compost Cool'},
    { id: 4, type: 'podcast', url: '2X2usgteKmmmtnqEPVdvvu', title: 'The Evangelical Christians Taking on Climate Change'}
  ];
  episode1Id: string = "4FKLKITaQbEshHvihVCec3";
  episode2Id: string = "2XiHg1jrEGWg3gXvyaUgvb";
  episode3Id: string = "36qB5r3TJmyYkZwp9wfmVx";
  episode4Id: string = "2X2usgteKmmmtnqEPVdvvu";

  constructor() { }

  ngOnInit(): void {
  }

}
